import { useMemo, useState } from "react";
import { useIntl } from "react-intl";
import type { ColumnDef } from "@tanstack/react-table";
import { SharedTable, useSharedTable } from "../../../shared/table";
import { construirColumnasInventario, ANCHO_MINIMO_INVENTARIO } from "./InventarioColumnas";
import type { FilaInventario } from "../types/inventario.types";

interface InventarioTablaProps {
    filas: FilaInventario[];
    cargando?: boolean;
    mostrarEstatus?: boolean;
    mensajeVacio?: string;
    busqueda?: boolean;
    onVerDetalle?: (fila: FilaInventario) => void;
    onEditar?: (fila: FilaInventario) => void;
    onDesactivar?: (fila: FilaInventario) => void;
    onReactivar?: (fila: FilaInventario) => void;
    columnasExtra?: ColumnDef<FilaInventario, unknown>[];
}

export const InventarioTabla = ({
    filas,
    cargando = false,
    mostrarEstatus = false,
    mensajeVacio,
    busqueda = false,
    onVerDetalle,
    onEditar,
    onDesactivar,
    onReactivar,
    columnasExtra = [],
}: InventarioTablaProps): JSX.Element => {
    const intl = useIntl();
    const [filaDetalle, setFilaDetalle] = useState<FilaInventario | null>(null);

    const textos = useMemo(
        () => ({
            clave: intl.formatMessage({ id: "input_clave" }),
            nombre: intl.formatMessage({ id: "input_nombre" }),
            tipoProducto: intl.formatMessage({ id: "select_tipo_producto" }),
            categoria: intl.formatMessage({ id: "select_categoria" }),
            unidadMedida: intl.formatMessage({ id: "select_unidad_medida" }),
            ubicacion: intl.formatMessage({ id: "select_ubicacion" }),
            almacen: intl.formatMessage({ id: "select_almacen" }),
            precio: intl.formatMessage({ id: "input_precio" }),
            cantidad: intl.formatMessage({ id: "input_cantidad" }),
            minimos: intl.formatMessage({ id: "input_minimos" }),
            maximos: intl.formatMessage({ id: "input_maximos" }),
            puntoReorden: intl.formatMessage({ id: "input_puntoReorden" }),
            estatus: intl.formatMessage({ id: "general_estatus" }),
            verDetalle: intl.formatMessage({ id: "general_ver_detalles" }),
            editar: intl.formatMessage({ id: "general_editar" }),
            desactivar: intl.formatMessage({ id: "general_desactivar" }),
            reactivar: intl.formatMessage({ id: "general_reactivar" }),
        }),
        [intl]
    );

    const columnas = useMemo(
        () =>
            construirColumnasInventario(
                {
                    onVerDetalle,
                    onEditar,
                    onDesactivar,
                    onReactivar
                },
                textos,
                mostrarEstatus,
                columnasExtra
            ),
        [onVerDetalle, onEditar, onDesactivar, onReactivar, textos, mostrarEstatus, columnasExtra]
    );

    const control = useSharedTable<FilaInventario>({
        columnas,
        datos: filas,
        obtenerIdFila: (fila) => fila.id,
    });

    return (
        <>
            <SharedTable
                control={control}
                cargando={cargando}
                busqueda={busqueda}
                anchoMinimo={ANCHO_MINIMO_INVENTARIO}
                mensajeVacio={mensajeVacio ?? intl.formatMessage({ id: "general_sin_registros" })}
            />
        </>

    );
};